/**
 * @name message-circle-text
 * @description Lucide SVG string.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMy4wODYgMTcuNTA5YTIgMiAwIDAwLS4wOTQtMS4xNjcgMTAgMTAgMCAxMTQuNzc3IDQuNzE5IDIgMiAwIDAwLTEuMDk5LS4wOTJsLTMuNDEzLjk5OGExIDEgMCAwMS0xLjIzNi0xLjE2OHoiIC8+CiAgPHBhdGggZD0iTTggMTJoOSIgLz4KICA8cGF0aCBkPSJNOCAxNmg1IiAvPgogIDxwYXRoIGQ9Ik04IDhoNyIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/message-circle-text
 * @see https://lucide.dev/guide/packages/lucide-static - Documentation
 *
 * @returns {String}
 *
 */
const MessageCircleText: string = `
<svg
  class="lucide lucide-message-circle-text"
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
>
  <path d="M3.086 17.509a2 2 0 00-.094-1.167 10 10 0 114.777 4.719 2 2 0 00-1.099-.092l-3.413.998a1 1 0 01-1.236-1.168z" />
  <path d="M8 12h9" />
  <path d="M8 16h5" />
  <path d="M8 8h7" />
</svg>
`;

export default MessageCircleText;
